import React from 'react';
import './NoPreview.css';

function NoPreview() {
  return (
    <div className="no-preview">
      <i className="fas fa-film"></i>
      <p>Video preview will appear here after selecting a file</p>
    </div>
  );
}

export default NoPreview; 